// 资源读取地址（下载/预览，建议 CDN 域名）
export const RESOURCE_READ_URL = import.meta.env.VITE_RESOURCE_READ_URL

// 资源上传地址（直传源站，建议对象存储网关域名）
export const RESOURCE_UPLOAD_URL = import.meta.env.VITE_RESOURCE_UPLOAD_URL

export const baseUrl = import.meta.env.BASE_URL

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export const socketBaseUrl = import.meta.env.VITE_WS_BASE_URL

export const enableTrace = import.meta.env.VITE_ENABLE_TRACE

export const txCaptchaAppId = import.meta.env.VITE_TX_CAPTCHA_APP_ID

export const wxOpenAppId = import.meta.env.VITE_WECHAT_OPEN_APP_ID

export default {
  RESOURCE_READ_URL,
  RESOURCE_UPLOAD_URL,
  baseUrl,
  apiBaseUrl,
  enableTrace,
  socketBaseUrl,
  txCaptchaAppId,
  wxOpenAppId
}
